import {LocaleMeta, SupportedLocale} from '@multipass-i18n';

import {I18nKey} from './i18nKey';

export interface LocaleDisplayMeta {
    nameKey: I18nKey;
    subKey?: I18nKey;
    glyph: string;
}

export const LOCALE_META = LocaleMeta as Record<SupportedLocale, LocaleDisplayMeta>;
